module.exports = __webpack_public_path__ + "assets/img/social/medium-icon.235e0915a71da900975eb73ee3ec92ef.svg";